// extracted by mini-css-extract-plugin
export default {"day":"WeatherItem_day__l0cgk","icon":"WeatherItem_icon__36w1Q"};